/**
*
* RedTestimonials
*
*/

import React from 'react';
import PropTypes from 'prop-types';

import defaultTextValues from './defaultTextValues';

import Wrapper from 'components/Templates/dynamics/Wrapper';

import authorImg from 'components/Templates/globalAssets/speakers/speakerblank.jpg';
import defaultLogo from 'assets/sample_logo_black.png';


function RedTestimonials(props) {

  const {
    commonData,
    commonProps,
  } = props;

  return (
    <Wrapper
      {...commonProps}
      
      typeOfStyle={'wrapper'}
      editorData={
        {
          editorType: 'wrapper',
          ...commonData
        }
      }
    >
      <Wrapper
        {...commonProps}
        
        typeOfStyle={'wrapperWithMargin'}
        editorData={
          {
            editorType: 'wrapperWithMargin',
            ...commonData
          }
        }
      >
        <Wrapper
          {...commonProps}
          
          typeOfStyle={'sectionTitle'}
          defaultValues={defaultTextValues}
          type={'text'}
          editorData={
            {
              editorType: 'sectionTitle',
              ...commonData
            }
          }
        />
        <Wrapper
          {...commonProps}
          
          typeOfStyle={'paragraph'}
          type={'text'}
          editorData={
            {
              editorType: 'paragraph',
              ...commonData
            }
          }
        />
        <Wrapper
          {...commonProps}
          
          typeOfStyle={'testimonialsWrapper'}
          editorData={
            {
              editorType: 'testimonialsWrapper',
              ...commonData
            }
          }
        >
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'testimonialWrapper'}
            editorData={
              {
                editorType: 'testimonialWrapper',
                ...commonData
              }
            }
          >
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'testimonialMark'}
              defaultValues={defaultTextValues}
              type={'text'}
              editorData={
                {
                  editorType: 'testimonialMark',
                  ...commonData
                }
              }
            />
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'testimonialOne'}
              defaultValues={defaultTextValues}
              type={'text'}
              editorData={
                {
                  editorType: 'testimonialOne',
                  ...commonData
                }
              }
            >
            </Wrapper>

            <Wrapper
              {...commonProps}
              
              typeOfStyle={'testimonialOneDescriptionWrapper'}
              editorData={
                {
                  editorType: 'testimonialOneDescriptionWrapper',
                  ...commonData
                }
              }
            >
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'testimonialOneAuthorTextWrapper'}
                editorData={
                  {
                    editorType: 'testimonialOneAuthorTextWrapper',
                    ...commonData
                  }
                }
              >
                <Wrapper
                  {...commonProps}
                  
                  typeOfStyle={'testimonialOneLogo'}
                  editorData={
                    {
                      editorType: 'testimonialOneLogo',
                      ...commonData
                    }
                  }
                  backgroundImage={defaultLogo}
                />
                <Wrapper
                  {...commonProps}
                  
                  typeOfStyle={'testimonialOneAuthor'}
                  defaultValues={defaultTextValues}
                  type={'text'}
                  editorData={
                    {
                      editorType: 'testimonialOneAuthor',
                      ...commonData
                    }
                  }
                >
                </Wrapper>
                <Wrapper
                  {...commonProps}
                  
                  typeOfStyle={'testimonialOneCompany'}
                  defaultValues={defaultTextValues}
                  type={'text'}
                  editorData={
                    {
                      editorType: 'testimonialOneCompany',
                      ...commonData
                    }
                  }
                >
                </Wrapper>
              </Wrapper>
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'testimonialOneAuthorAvatar'}
                editorData={
                  {
                    editorType: 'testimonialOneAuthorAvatar',
                    ...commonData
                  }
                }
                backgroundImage={authorImg}
              />
            </Wrapper>
          </Wrapper>
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'testimonialWrapper'}
            editorData={
              {
                editorType: 'testimonialWrapper',
                ...commonData
              }
            }
          >
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'testimonialMark'}
              defaultValues={defaultTextValues}
              type={'text'}
              editorData={
                {
                  editorType: 'testimonialMark',
                  ...commonData
                }
              }
            />
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'testimonialTwo'}
              defaultValues={defaultTextValues}
              type={'text'}
              editorData={
                {
                  editorType: 'testimonialTwo',
                  ...commonData
                }
              }
            >
            </Wrapper>

            <Wrapper
              {...commonProps}
              
              typeOfStyle={'testimonialTwoDescriptionWrapper'}
              editorData={
                {
                  editorType: 'testimonialTwoDescriptionWrapper',
                  ...commonData
                }
              }
            >
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'testimonialTwoAuthorTextWrapper'}
                editorData={
                  {
                    editorType: 'testimonialTwoAuthorTextWrapper',
                    ...commonData
                  }
                }
              >
                <Wrapper
                  {...commonProps}
                  
                  typeOfStyle={'testimonialTwoLogo'}
                  editorData={
                    {
                      editorType: 'testimonialTwoLogo',
                      ...commonData
                    }
                  }
                  backgroundImage={defaultLogo}
                />
                <Wrapper
                  {...commonProps}
                  
                  typeOfStyle={'testimonialTwoAuthor'}
                  defaultValues={defaultTextValues}
                  type={'text'}
                  editorData={
                    {
                      editorType: 'testimonialTwoAuthor',
                      ...commonData
                    }
                  }
                >
                </Wrapper>
                <Wrapper
                  {...commonProps}
                  
                  typeOfStyle={'testimonialTwoCompany'}
                  defaultValues={defaultTextValues}
                  type={'text'}
                  editorData={
                    {
                      editorType: 'testimonialTwoCompany',
                      ...commonData
                    }
                  }
                >
                </Wrapper>
              </Wrapper>
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'testimonialTwoAuthorAvatar'}
                editorData={
                  {
                    editorType: 'testimonialTwoAuthorAvatar',
                    ...commonData
                  }
                }
                backgroundImage={authorImg}
              />
            </Wrapper>
          </Wrapper>
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'testimonialWrapper'}
            editorData={
              {
                editorType: 'testimonialWrapper',
                ...commonData
              }
            }
          >
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'testimonialMark'}
              defaultValues={defaultTextValues}
              type={'text'}
              editorData={
                {
                  editorType: 'testimonialMark',
                  ...commonData
                }
              }
            />
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'testimonialThree'}
              defaultValues={defaultTextValues}
              type={'text'}
              editorData={
                {
                  editorType: 'testimonialThree',
                  ...commonData
                }
              }
            >
            </Wrapper>

            <Wrapper
              {...commonProps}
              
              typeOfStyle={'testimonialThreeDescriptionWrapper'}
              editorData={
                {
                  editorType: 'testimonialThreeDescriptionWrapper',
                  ...commonData
                }
              }
            >
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'testimonialThreeAuthorTextWrapper'}
                editorData={
                  {
                    editorType: 'testimonialThreeAuthorTextWrapper',
                    ...commonData
                  }
                }
              >
                <Wrapper
                  {...commonProps}
                  
                  typeOfStyle={'testimonialThreeLogo'}
                  editorData={
                    {
                      editorType: 'testimonialThreeLogo',
                      ...commonData
                    }
                  }
                  backgroundImage={defaultLogo}
                />
                <Wrapper
                  {...commonProps}
                  
                  typeOfStyle={'testimonialThreeAuthor'}
                  defaultValues={defaultTextValues}
                  type={'text'}
                  editorData={
                    {
                      editorType: 'testimonialThreeAuthor',
                      ...commonData
                    }
                  }
                >
                </Wrapper>
                <Wrapper
                  {...commonProps}
                  
                  typeOfStyle={'testimonialThreeCompany'}
                  defaultValues={defaultTextValues}
                  type={'text'}
                  editorData={
                    {
                      editorType: 'testimonialThreeCompany',
                      ...commonData
                    }
                  }
                >
                </Wrapper>
              </Wrapper>
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'testimonialThreeAuthorAvatar'}
                editorData={
                  {
                    editorType: 'testimonialThreeAuthorAvatar',
                    ...commonData
                  }
                }
                backgroundImage={authorImg}
              />
            </Wrapper>
          </Wrapper>
        </Wrapper>
      </Wrapper>
    </Wrapper>
  );

}

RedTestimonials.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
};

export default RedTestimonials;
